import React, {useEffect, useState} from 'react';
import api from '../services/api';
import AssignUsersModal from './AssignUsersModal';
import '../styles/ProjectModal.css';

export default function ProjectModal({project, onClose, onSave}) {
    const [customers, setCustomers] = useState([]);
    const [form, setForm] = useState({
        id: null, name: '', description: '', customerId: ''
    });
    const [showAssignModal, setShowAssignModal] = useState(false);


    useEffect(() => {
        api.get('/company').then(res => setCustomers(res.data));
        if (project) {
            setForm(project);
        }
    }, [project]);

    const handleChange = e => {
        const {name, value} = e.target;
        setForm(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = () => {
        if (!form.name || !form.description || !form.customerId) {
            alert("Please fill all fields");
            return;
        }
        if (form.id) {
            api.patch(`/project/${form.id}`, form).then(onSave);
        } else {
            api.post('/project', {
                'name': form.name,
                'description': form.description,
                'companyID': form.customerId
            }).then(onSave);
        }
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>{form.id ? "Projekt anpassen" : "Projekt hinzufügen"}</h3>
                <input name="name" placeholder="Name" value={form.name} onChange={handleChange} className="input"/>
                <input name="description" placeholder="Beschreibung" value={form.description} onChange={handleChange}
                       className="input"/>
                <select name="customerId" value={form.customerId} onChange={handleChange} className="input">
                    <option value="">Kunde auswählen</option>
                    {customers.map(c => (
                        <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                </select>
                <br></br>
                <button className="button" onClick={() => setShowAssignModal(true)}>User zuweisen</button>

                {showAssignModal && (
                    <AssignUsersModal
                        projectId={form.id}
                        onClose={() => setShowAssignModal(false)}
                    />
                )}

                <div style={{marginTop: '15px'}}>
                    <button className="button-normal" onClick={handleSubmit}>Speichern</button>
                    <button className="button-danger" onClick={onClose}>Abbrechen</button>
                </div>
            </div>
        </div>
    );
}
